import React from 'react';
import { useAuthStore } from '../../../context/AuthContext';
import { ChemicalOrderPortCall } from '../../../types/ViewModel/TankCleaning/Order/ChemicalOrderPortCall';
import { isDateBefore } from 'odfjell-date-time-utils/dateTimeUtils';
import OrderStatus from './OrderStatus';

type Props = {
    chemicalOrderForPortCallList: ChemicalOrderPortCall[];
    iconsRightPos: number;
};

const OrderStatusIconList: React.FC<Props> = (props) => {
    const { role } = useAuthStore();

    const getIconRightPos = (index: number) => {
        return (props.iconsRightPos + index * 15).toString() + 'px';
    };

    return (
        <>
            {role &&
                props.chemicalOrderForPortCallList &&
                props.chemicalOrderForPortCallList.length > 0 &&
                props.chemicalOrderForPortCallList
                    .sort((a, b) => (isDateBefore(a.createdUtc, b.createdUtc) ? 1 : -1))
                    .filter((c) => c.parentOrderId === 0)
                    .map((chemicalOrder, index) => {
                        return (
                            <OrderStatus
                                chemicalOrderStatus={chemicalOrder.lastOrderStatusId}
                                type={'icon'}
                                rightPos={getIconRightPos(index)}
                                key={`order_status_icon${chemicalOrder.lastOrderStatusId}_${index}`}
                            ></OrderStatus>
                        );
                    })}
        </>
    );
};

export default OrderStatusIconList;
